import { useState, useEffect } from 'react';
import { X, Sparkles } from 'lucide-react';
import { Button } from '@/components/ui/button';

const GREETINGS = [
  "Welcome back! Ready to improve your call quality today?",
  "Great to see you! Let's make today productive.",
  "Hello there! Your coaching insights are waiting for you.",
  "Welcome! Check out your latest performance metrics.",
  "Hi! New coaching tips are available for you today.",
];

export default function GreetingPopup({ userName, onClose }) {
  const [isVisible, setIsVisible] = useState(true);
  const [greeting] = useState(() => GREETINGS[Math.floor(Math.random() * GREETINGS.length)]);

  useEffect(() => {
    // Auto-close after 4 seconds
    const timer = setTimeout(() => {
      handleClose();
    }, 4000);

    return () => clearTimeout(timer);
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    setTimeout(() => {
      onClose?.();
    }, 300); // Wait for animation
  };

  if (!isVisible) return null;

  return (
    <div className={`fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/30 backdrop-blur-sm transition-opacity duration-300 ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
      <div className={`bg-gradient-to-br from-blue-600 via-indigo-600 to-purple-600 rounded-2xl p-8 max-w-md w-full shadow-2xl transform transition-all duration-300 ${isVisible ? 'scale-100' : 'scale-95'}`}>
        <Button
          variant="ghost"
          size="sm"
          className="absolute top-4 right-4 text-white/70 hover:text-white hover:bg-card/20"
          onClick={handleClose}
        >
          <X className="h-5 w-5" />
        </Button>

        <div className="text-center text-white">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-card/20 rounded-full mb-6">
            <Sparkles className="h-8 w-8" />
          </div>
          
          <h2 className="text-2xl font-bold mb-2">
            Hi, {userName || 'there'}! 👋
          </h2>
          
          <p className="text-blue-100 text-lg mb-6">
            {greeting}
          </p>

          <div className="flex justify-center gap-3">
            <Button
              onClick={handleClose}
              className="bg-card text-indigo-600 hover:bg-blue-50"
            >
              Let's Go!
            </Button>
          </div>

          {/* Progress bar for auto-close */}
          <div className="mt-6 h-1 bg-card/20 rounded-full overflow-hidden">
            <div 
              className="h-full bg-card rounded-full animate-shrink"
              style={{ animation: 'shrink 4s linear forwards' }}
            />
          </div>
        </div>
      </div>

      <style>{`
        @keyframes shrink {
          from { width: 100%; }
          to { width: 0%; }
        }
      `}</style>
    </div>
  );
}
